import React from 'react';
import cn from 'clsx';

import Image from '../../library/image/image';

import { getProductFitmentPosition } from '../../shared/utils/product/product';

import { ProductData } from '../../shared/types/graphql-types';

import styles from './product-set-image.scss';

interface ProductSetImageProps {
  product: ProductData;
}

function ProductSetImage(props: ProductSetImageProps) {
  const { product } = props;
  const productFitmentPosition = getProductFitmentPosition(product);
  const positionSrc =
    productFitmentPosition?.split(' ')[0]?.toLowerCase() || '';

  if (!positionSrc) {
    return null;
  }

  return (
    <Image
      alt={`fitment position ${productFitmentPosition}`}
      className={cn(styles['fitment-position'], 'product-set-image')}
      src={`https://discounttire.scene7.com/is/content/discounttire/logos/icons/${positionSrc}.svg`}
    />
  );
}

export default ProductSetImage;
